import { ConfigurationCode } from '../ConfigurationCode';

export class ConfigurationCodeMapper {
  static toDomain(dto: SimpleProjectServiceAPI.ConfigurationCodeDto): ConfigurationCode {
    return new ConfigurationCode(dto.configurationCodeSuffix, dto.projectCode);
  }
  static toDto(code: ConfigurationCode): SimpleProjectServiceAPI.ConfigurationCodeDto {
    return { configurationCodeSuffix: code.configurationCodeSuffix, projectCode: code.projectCode };
  }
}
